var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube 1",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M 106.962 0L 28.0378 0C 12.5529 0 0 11.8263 0 26.4149L 0 63.5851C 0 78.1737 12.5529 90 28.0378 90L 106.962 90C 122.447 90 135 78.1737 135 63.5851L 135 26.4149C 135 11.8263 122.447 0 106.962 0ZM 88.0005 46.8085L 51.0849 63.3958C 50.1013 63.8378 48.9651 63.1622 48.9651 62.1356L 48.9651 27.924C 48.9651 26.8828 50.1312 26.208 51.1169 26.6786L 88.0324 44.3028C 89.13 44.8267 89.1109 46.3097 88.0005 46.8085Z",
    transform: "translate(33 55)",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 100,
    cy: 100,
    r: 95,
    stroke: "#FF0000",
    strokeWidth: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4326747dae9c6aae6a02fedca1851ed8.svg";
export { ForwardRef as ReactComponent };